export var ProviderType;
(function (ProviderType) {
    ProviderType[ProviderType["Device"] = 0] = "Device";
    ProviderType[ProviderType["Controller"] = 1] = "Controller";
})(ProviderType || (ProviderType = {}));
export class Update {
    constructor() {
        this.UpdateGuid = "";
        this.Channel = "";
        this.Version = "";
        this.CurrentVersion = "";
        this.DownloadUri = "";
        this.Download = "";
        this.Name = "";
        this.Description = "";
        this.UpdateType = UpdateTypes.Unknown;
        this.ResourceGuid = "";
    }
}
export class UpdateInfo {
    constructor() {
        this.UpdateDescription = new Map();
        this.Update = new Update();
        this.UpdatedResourceName = "";
        this.CurrentResourceVersion = "";
    }
}
export var UpdateTypes;
(function (UpdateTypes) {
    UpdateTypes[UpdateTypes["Unknown"] = 0] = "Unknown";
    UpdateTypes[UpdateTypes["Container"] = 1] = "Container";
    UpdateTypes[UpdateTypes["RadioFirmware"] = 2] = "RadioFirmware";
    UpdateTypes[UpdateTypes["DeviceFirmware"] = 3] = "DeviceFirmware";
    UpdateTypes[UpdateTypes["Configuration"] = 4] = "Configuration";
    UpdateTypes[UpdateTypes["ContainerScript"] = 5] = "ContainerScript";
    UpdateTypes[UpdateTypes["ContainerSoftware"] = 6] = "ContainerSoftware";
    UpdateTypes[UpdateTypes["RuntimeSoftware"] = 7] = "RuntimeSoftware";
    UpdateTypes[UpdateTypes["RuntimeScript"] = 8] = "RuntimeScript";
    UpdateTypes[UpdateTypes["RuntimeFixingScript"] = 9] = "RuntimeFixingScript";
})(UpdateTypes || (UpdateTypes = {}));
//Errors
export class UpdatesProviderNotFound extends Error {
    constructor(message) {
        super(message);
        this.message = message;
        this.name = "UpdateProviderNotFound";
    }
}
//# sourceMappingURL=IUpdatesProvider.js.map